// extracted by mini-css-extract-plugin
module.exports = {"comp":"TC_Footer_comp__6hBzv"};